import { postSmsCampaign } from '../services';
export const createSmsCampaign = (params) => postSmsCampaign(params)
    .then(response => formatResponse(response?.data))
    .catch(() => false);
const formatResponse = (response) => {
    return response.success;
};
